<template>
    <propertyPop ref="pop" type="photo" @hide="beforeHide" :class="{'grid': isGridView, 'zoom-mode':active, 'zoom-in': isZoomIn, subtitle: hasCategories, 'pop-photo-cate-view': showPhotoCategories, bottom:isEnd, vertical: isListView, hotleadmode:showHotleadForm}" v-ga:pop="{pageType: 'vdppphoto', glb: glb, state: dpp}">
        <template v-slot:header>
            <div>
                <div class="f6 flex left property-pop-buttons">
                    <button type="button" @click="toggleView" class="link hidden-md hidden-lg"><i :class="isGridView? 'icon-deck' :'icon-galleryview'"></i> <span>{{ isGridView ? 'List' : 'Grid'}}</span></button>
                </div>
            </div>
        </template>
        <template v-slot:body>
            <div class="property-popphoto-single-count" v-if="imageIndex < photoList.length">
                <span>
                    {{imageIndex + 1}} / {{photoList.length}}
                </span>
            </div>
            <div class="property-popphoto-single" ref="container">
                <a @click="zoomOut" class="single-close-zoom"><i class="icon-angle-left"></i></a>
                <div ref="figure" v-if="getCurrentPhoto" @click="onClickImg" @mousemove="mouseMove" class="single-img-zoom" :class="{moving: moving}"  :style="coreStyle">
                    <img ref="prevPhoto" v-if="isListView && getPrevPhoto" class="prev" />
                    <img ref="currentPhoto" @load="onImgLoad" @touchstart="touchStart" class="current" :class="{'current-watermark': showWatermark()}" @touchend="touchEnd"  @touchmove="touchMove" :src="getCurrentPhoto.src_l ? getCurrentPhoto.src_l : (getCurrentPhoto.path + getCurrentPhoto._l)" />
                    <img ref="nextPhoto" v-if="isListView && getNextPhoto" class="next" />
                </div>
                <div v-if="prepareHotleadForm" class="property-popphoto-single-form slider">
                    <mvtHotleadForm :options="hotleadOpt" />
                </div>

                <div v-if="isSM || (!showPhotoCategories)" v-once class="property-popphoto-single-list property-pop-scroller" ref="thumbnail">
                    <ul>
                        <template v-for="(item, index) in photoList">
                            <li class="photo"  :data-index="index" :data-cateIndex="item.cateIndex" :data-photoIndex="item.index">
                                <img loading="lazy" :alt="item.cate" :src="item.src ? item.src : (item.path + item._p)">
                            </li>
                        </template>
                        <li class="form" ref="hotleadForm" :data-index="photoList.length">
                            <div class="property-popphoto-single-form">
                                <mvtHotleadForm :options="hotleadOpt" />
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="property-photo-nav single-nav" v-if="showPhotoCategories">
                    <a v-for="item in getCategories" :data-nav="item.cateIndex" @click="updateById(item.cateIndex, 0)">
                        <img :title="`${item.tag} ${item.tag ? '-' : ''} ${dpp.geo.formatAddress} photo ${item.index + 1}${item.count ? ` of ${item.count}` : ''}`" :alt="dpp.geo.formatAddress" :src="item.path + item._p">
                        <span v-if="item.tag">{{`${item.tag}`}}</span>
                    </a>
                </div>
                <a v-if="!isFirst" class="popphoto-single-left default" @click="_prev"><i class="f4 icon-angle-left"></i></a>
                <a v-if="!isLast" class="popphoto-single-right default" @click="_next"><i class="f4 icon-angle-right"></i></a>
            </div>
        </template>
    </propertyPop>
</template>
<script src="./property-popphotosingle.js"></script>

<style lang="scss">
@use "./property-popphotosingle.scss" as *;
</style>
